import { ButtonConfig } from '@zipari/shared-ds-util-button';
import { EventInfo } from '@zipari/shared-ds-util-digital-data';
import { Condition } from '@zipari/shared-ds-util-form';
import { ObjectStatuses } from '@zipari/shared-ds-util-status';
import { DatagridSortDirection } from './datagrid.constants';

interface ActionIcon {
  action: string;
  icon: string;
}

export interface DatagridColumn {
  action?: string;
  actionIcons?: ActionIcon[];
  conditions?: Condition;
  endProp?: string;
  format: string;
  icon?: string;
  isLeftAligned?: boolean;
  isCenterAligned?: boolean;
  isRightAligned?: boolean;
  label: string;
  prop?: string;
  routeToProp?: string;
  route?: string;
  ssoLinkLabel?: string;
  showActionIconsLabel?: boolean;
  sortable?: boolean;
  sortByProp?: string;
  startProp?: string;
  statuses?: ObjectStatuses;
  tooltipProp?: string;
  width?: string;
  link?: string;
  options?: {
    label: string;
  };
  digitalData?: Pick<
    EventInfo,
    'effect' | 'eventAction' | 'eventName' | 'type'
  >;
  /** Applied to data grid mobile header */
  valueInNextLine?: boolean;
  limit?: number;
  noValueMessage?: string;
}

export interface DatagridCardConfiguration {
  isExpandable?: boolean;
  maxVisibleCells?: number;
  valuesAlignment?: 'right';
  footerStyle?: 'plain';
  expandButton?: object;
}

export interface Datagrid {
  mobileConfiguration?: DatagridCardConfiguration;
  isHeaderBold?: boolean;
  hideUnusedColumns?: boolean;
  columns: DatagridColumn[];
  initSort?: DatagridInitSort;
  fillWindow?: boolean;
  isScrollable?: boolean;
  isSelectable?: boolean;
  exportFileType?: string;
  noData?: DatagridNoData;
  error?: DatagridError;
  rowLimit?: number;
  selectionAction?: {
    icon: string;
    label: string;
  };
  hideStatusBackground?: boolean;
  statuses: {
    error?: string;
    expired?: string;
    info?: string;
    pending?: string;
    success?: string;
  };
  selectedRowsTitle?: string;
  button?: ButtonConfig;
  showSummaryRow?: boolean;
}

export interface DatagridError {
  imageUrl?: string;
  message?: string;
  showHeader?: boolean;
}

export interface DatagridNoData extends DatagridError {
  imageWidth?: string;
}

// Not used in this component anymore but may be used in parent components.
// If this was used in your datagrid configs previously you can now use the datagrid
// input 'sortOrder' and control its value and sorting functionality in the parent component.
export interface DatagridInitSort {
  columnProp: string;
  sortDirection?: DatagridSortDirection;
}

export interface DatagridTextWithIconConfiguration {
  value: string;
  color: string;
  tooltip?: string;
  leftAlign?: boolean;
  directionTop?: boolean;
}

export interface DatagridTooltip {
  description: string;
  leftAlign?: boolean;
  directionTop?: boolean;
}
